import { RpcService } from 'rpc';

export interface ProgressionReturn {
	access: string[];
	progression: string;
}

export interface IQuiz extends RpcService {
	results(params: { select?: Record<string, any> }): Promise<any>;
	one_result(params: { qrid: number }): Promise<any>;
	questionresults(params: { qrid: number; select?: Record<string, any> }): Promise<any>;
	update_annotation(params: { userid: string }): Promise<any>;
	possible_testbanks(): Promise<any>;
	quiz_selectors(): Promise<any>;
	quiz_qorders(): Promise<any>;
	quiz_workflows(): Promise<any>;
	progression(): Promise<ProgressionReturn>;
	score_by_module(): Promise<any>;
}

export const svc: IQuiz = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `@@quizfolder.rpc`,

	services: {
		results: {
			parameters: [{ name: 'select', type: 'object', optional: true }]
		},
		one_result: {
			parameters: [{ name: 'qrid', type: 'number', optional: false }]
		},
		questionresults: {
			parameters: [
				{ name: 'qrid', type: 'number', optional: false },
				{ name: 'select', type: 'object', optional: true }
			]
		},
		update_annotation: {
			parameters: [{ name: 'userid', type: 'string', optional: false }]
		},
		possible_testbanks: {
			parameters: [{}]
		},
		quiz_selectors: {
			parameters: [{}]
		},
		quiz_qorders: {
			parameters: [{}]
		},
		quiz_workflows: {
			parameters: [{}]
		},
		progression: {
			parameters: []
		},
		score_by_module: {
			parameters: []
		}
	}
}) as IQuiz;

export default svc;
